module.exports = __webpack_public_path__ + "onefinestay-logo.png?10e85c147c887d72f34c88d71bebf616";